export default {
    MigrateOutlookFavorites: {
        name: 'MigrateOutlookFavorites',
        options: {
            isCore: true,
        },
    },

    UpdateFavoriteNode: {
        name: 'UpdateFavoriteNode',
    },
};
